import { Component, OnInit } from '@angular/core';
import { DynamicScriptLoaderService } from '../../../../services/dynamic-script-loader.service';
declare var ymaps: any;
@Component({
  selector: 'app-modal-map',
  templateUrl: './modal-map.component.html',
  styleUrls: ['./modal-map.component.css']
})
export class ModalMapComponent implements OnInit {
  public data: any;
  public map: any;
  constructor(public dynamicScriptLoaderService: DynamicScriptLoaderService) {}
  ngOnInit(): void {
    this.dynamicScriptLoaderService.load(['yandex-map']).then(() => {
      ymaps.ready().then(() => {
        this.map = new ymaps.Map('map', {
          center: [this.data.latitude, this.data.longitude],
          zoom: 15
        });
        const myPlacemark = new ymaps.Placemark(
          [this.data.latitude, this.data.longitude],
          {
            //hintContent: 'Собственный значок метки с контентом',
            //balloonContent: 'А эта — новогодняя',
            //iconContent: '12'
          },
          {}
        );
        this.map.geoObjects.add(myPlacemark);
      });
    });
  }
}
